/* eslint-disable no-multi-str */
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import React from "react";
import styled from "styled-components";
import { getTitle } from "../helpers/getTitle";
import { DiAsterisk } from "react-icons/di";

export default function EmailColumnRenderer(params) {
  let _url = "";
  let _urlHref = "#";
  if (params?.data?.row_id === "+") return null;
  if (params.colDef.colId === "userEvents") return null;
  let highlightIconColor = "";
  let highlightDuplicates = false;

  if(!params?.store?.isSubsheet && params.colDef?.cellRendererParams?.columnOptions?.is_highlighted && params.value !== '' && (params.store.duplicateColumnsData[params.colDef.dataIndex] && params.store.duplicateColumnsData[params.colDef.dataIndex][params.value] && params.store.duplicateColumnsData[params.colDef.dataIndex][params.value]>1)){
    highlightDuplicates = true;
    highlightIconColor = params.store.duplicateColumnsData['themeColor'] ? params.store.duplicateColumnsData['themeColor'] : '';
  }
  
  if(params?.store?.isSubsheet && params.colDef?.cellRendererParams?.columnOptions?.is_highlighted && params.value !== '' && (params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId] && params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId][params.value] && params.store.duplicateColumnsData[params.colDef.dataIndex + '_' + params?.store.parentRowId][params.value]>1)){
    highlightDuplicates = true;
    highlightIconColor = params.store.duplicateColumnsData['themeColor'] ? params.store.duplicateColumnsData['themeColor'] : '';
  }

  if (params.value && typeof params.value !== "string") {
    params.value = params.value.toString();
  }
  var val = params.value && params.value !== "undefined" ? params.value : "";
  if (
    val.match(
      /^(([^<>()\[\]\\.,;\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  ) {
    val.replace(
      /^(([^<>()\[\]\\.,;\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      function (url) {
        var urlHref;
        if (
          url.match(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ) {
          urlHref = "mailto:" + url;
        }
        _url = url;
        _urlHref = urlHref;
      }
    );
  } else {
    return val;
  }

  const deselectAllSelectedNodes = () => {
    params.store.resetSelectedRecordsCount();
    let selectedNodes = params.api.gridPanel.gridApi.getSelectedNodes();
    selectedNodes.map((node) => {
      let rowNode = params.api.gridPanel.gridApi.getRowNode(node.id);
      rowNode.setSelected(false);
    });
    let parentDOM = document.getElementById(params.store.gridId);
    let array = Array.from(parentDOM.getElementsByClassName("rowIdSelection"));
    parentDOM.querySelectorAll("input[id='defaultChecked']")[0].checked = false;
    array.map((row) => {
      if (row.checked) {
        row.checked = false;
      }
    });
  };

  const selectCurrentRow = () => {
    deselectAllSelectedNodes();
    params.node.setSelected(true, false);
    let parentDOM = document.getElementById(params.store.gridId);
    if (!parentDOM.getElementsByClassName(params.node.data.uniqueId)[0].checked) {
      params.store.addSelectedRecordsCount(1);
      parentDOM.getElementsByClassName(params.node.data.uniqueId)[0].checked = true;
    }
    params.store.isMailModalVisible = true;
  };

  const emailURLIdName = highlightDuplicates && params.store.isSubsheet ? "email_clipped_highlight_subsheet" : highlightDuplicates ? "email_clipped_highlight" : "email_clipped";
  const emailHighlightIdName = highlightDuplicates && params.store.isSubsheet ? "highlightIcon_Subsheet" : "highlightIcon";

  return (
    <StyledDiv
      height={params.node.rowHeight}
      width={params.colDef.width}
      title={getTitle(params, params.cellMetaData)}
    >
      <StyledWrapper>
        <StyledLink href={_urlHref} className="email_clipped" id={emailURLIdName}>
          {_url}
        </StyledLink>
        {
          highlightDuplicates && (
            <DiAsterisk style={{
              position: 'absolute',
              top: '-5px',
              right: '15px',
              fontSize: '20px'
            }}
            className='highlightIcon'
            id={emailHighlightIdName}
            color = {highlightIconColor} />)
        }
        {!params.store.isSubsheet && (
          <StyledIcondiv className="email_icon">
            {
              highlightDuplicates && (
                <DiAsterisk style={{
                  fontSize: '20px'
                }}
                className='highlightIcon'
                color = {highlightIconColor} />)
            }
            <MailOutlineIcon onClick={selectCurrentRow} fontSize="small" color="secondary" />
          </StyledIcondiv>
        )}
        <div className="email_div_hidden" style={{ width: "10px" }}></div>
      </StyledWrapper>
    </StyledDiv>
  );
}

const StyledDiv = styled.div`
  && {
    height: ${(props) => props.height}px;
    width: ${(props) => props.width}px;
    padding-top: 10px;
    position: relative;
  }
`;

const StyledWrapper = styled.div`
  && {
    position: relative;
    line-height: normal;
    width: 100%;
    overflow: visible;
    display: flex;
    justify-content: space-between;
  }
`;

const StyledLink = styled.a`
  && {
    width: 80%;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const StyledIcondiv = styled.div`
  && {
    padding: 0px 20px 0 5px;
    background-color: transparent;
  }
`;
